import { render, staticRenderFns } from "./createDefaultText.vue?vue&type=template&id=0cc2893f&scoped=true"
import script from "./createDefaultText.vue?vue&type=script&lang=js"
export * from "./createDefaultText.vue?vue&type=script&lang=js"
import style0 from "./createDefaultText.vue?vue&type=style&index=0&id=0cc2893f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2893f",
  null
  
)

export default component.exports